const ScpPermissions = {
    None: { text: "None", name: "SCP_None", value: 0, hidden: true },
    SCP_UserData: { text: "User Data", name: "SCP_UserData", value: 1 },
    SCP_SensitiveUserData: { text: "Sensitive User Data", name: "SCP_SensitiveUserData", value: 2 },
    SCP_RoleManagement: { text: "Role Management", name: "SCP_RoleManagement", value: 4 },
    SCP_Inventory: { text: "Inventory", name: "SCP_Inventory", value: 8 },
    SCP_StatusEffects: { text: "Status Effects", name: "SCP_StatusEffects", value: 16 },
    SCP_Kick: { text: "Kick", name: "SCP_Kick", value: 32 },
    SCP_Ban: { text: "Ban", name: "SCP_Ban", value: 64 },
    SCP_Mutes: { text: "Mutes", name: "SCP_Mutes", value: 128 },
    SCP_Administration: { text: "Administration", name: "SCP_Administration", value: 256 },
    SCP_Broadcasting: { text: "Broadcasting", name: "SCP_Broadcasting", value: 512 },
    SCP_StaffChat: { text: "Staff Chat", name: "SCP_StaffChat", value: 1024 },
    SCP_RoundEvents: { text: "Round Events", name: "SCP_RoundEvents", value: 2048 },
    SCP_RespawnEvents: { text: "Respawn Events", name: "SCP_RespawnEvents", value: 4096 },
    SCP_MapControl: { text: "Map Control", name: "SCP_MapControl", value: 8192 },
    SCP_Cassie: { text: "Map Control", name: "SCP_Cassie", value: 16384 },
    SCP_ServerConsoleCommands: { text: "Server Console Commands", name: "SCP_ServerConsoleCommands", value: 32768 },
};

export default ScpPermissions;